export enum DisasterStatus {
  Impossible,
  Possible,
  Unknown
}
